import { axiosGetWithCookies } from './helper';
import { startOfDay, endOfDay } from '../utils/time';

export const fetchMaintainerTaskListPdf = ({
  dateFrom,
  dateTo,
  businessClient,
  search,
  timezone,
  site,
  status,
  limit = 50,
  taskType,
  language,
}) => {
  let query = `/tasks/tasks/reporting/pdf?&limit=${limit}`;
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }
  /* eslint-disable no-param-reassign */
  query += Array.isArray(taskType)
    ? taskType.reduce((acc, c) => (acc += `&taskType=${c.id}`), '')
    : `&taskType=${taskType}`;
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (site) query += `&siteId=${site}`;

  if (timezone) query += `&timezone=${timezone || 'UTC'}`;
  if (search) query += `&search=${search}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};
